import React, { useState,useEffect } from 'react';
import { toast } from 'react-toastify';
import {format } from 'date-fns';
import { getDefaultReviewList,getSingleReviewTemplateDetail,searchTripadvisorReview } from "../../../../utils/reviewApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import RatingStars from "../../../../components/RatingStars";

const FloatingWidget = ({selectedLayout,isTemplateId, widgetId,reviewTabData}) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  // Default values for the reviewTabData
  const {
      is_website_frontend,
      business_name,
      style_background_color,
      header_is_widget_title,
      header_title,
      header_caption,
      setting_rating_format,
      style_widget_title_color,
      style_widget_title_fonts_title_size,
      style_widget_title_caption_color,
      style_widget_title_fonts_caption_size,
      style_header_background_color,
      header_is_show_header,
      header_write_reviews_button,
      header_source_icon,
      header_rating,
      header_number_of_reviews,
      style_header_text_color,
      style_header_write_review_background_color,
      style_header_write_review_text_color,
      header_write_review_button_type,
      style_rating_stars_color,
      style_load_more_button_color,
      style_load_more_button_text_color,
  } = reviewTabData || {};

  //Handle when clicking "Read More"
  const handleReadMoreClick = (review) => {
    setExpandedReviewId(prev =>
      prev === review.id ? null : review.id
    );
  };

  //Handle Main Popup
  const togglePopup = () => {
      setShowPopup(!showPopup);
  };

  // Load More function
  const handleLoadMore = () => {
      setVisibleCount((prevCount) => prevCount + 5);
  };

  // Fetching Review data
  useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          try {
              let result;
              if (isTemplateId) {
                  result = await getSingleReviewTemplateDetail(isTemplateId);
              } else if (widgetId) {
                  result = await getSingleWidgetDetail(widgetId);
              } else if (business_name) {
                const payload = { business_name: business_name };
                result = await searchTripadvisorReview(payload);
              } else {
                  let app_type = 'Tripadvisor_Review';
                  result = await getDefaultReviewList(app_type);
              }
              setApiData(result);
          } catch (error) {
              toast.warning(error.message);
          } finally {
              setLoading(false); 
          }
      };

      fetchData();
  }, [isTemplateId, widgetId, business_name]);

  return (
    <>
      <div className={`upgadeify-review-template-widget ${loading ? '': 'upgadeify-floating-style'} ${showPopup ? 'main-popup-open' : ''} ${is_website_frontend}`}>
        {/* Loader and No Api Data Handling */}
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
              <p>Loading please wait...</p>
          </div>
        ) : apiData?.status === true ? (
        <>
        <div className='upgadeify-badge-style-header' onClick={togglePopup}>
          <div className='upgadeify-badge-header-title'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><circle cx="12" cy="12.5" r="10" fill="#34E0A1"></circle><path fill="#000" d="m18.167 10.528 1.194-1.306h-2.667A8.236 8.236 0 0 0 12 7.778c-1.75 0-3.361.528-4.694 1.444H4.639l1.194 1.306c-.75.666-1.194 1.639-1.194 2.722a3.663 3.663 0 0 0 3.667 3.667c.972 0 1.833-.362 2.5-.973L12 17.222l1.167-1.278a3.652 3.652 0 0 0 2.5.973 3.663 3.663 0 0 0 3.666-3.667 3.584 3.584 0 0 0-1.166-2.722Zm-9.834 5.194a2.49 2.49 0 0 1-2.5-2.5 2.49 2.49 0 0 1 2.5-2.5 2.49 2.49 0 0 1 2.5 2.5c-.027 1.39-1.139 2.5-2.5 2.5ZM12 13.167c0-1.64-1.194-3.056-2.75-3.64A7.049 7.049 0 0 1 12 8.973a6.95 6.95 0 0 1 2.75.556c-1.556.61-2.75 2-2.75 3.639Zm3.667 2.555a2.49 2.49 0 0 1-2.5-2.5 2.49 2.49 0 0 1 2.5-2.5 2.49 2.49 0 0 1 2.5 2.5 2.49 2.49 0 0 1-2.5 2.5Zm0-3.778c-.723 0-1.306.584-1.306 1.306a1.304 1.304 0 1 0 2.611 0c0-.722-.583-1.306-1.305-1.306ZM9.639 13.25c0 .722-.583 1.306-1.306 1.306a1.304 1.304 0 0 1-1.305-1.306 1.304 1.304 0 1 1 2.611 0Z"></path></svg>
            <div className='upgadeify-badge-reviews-header-title-text'>Tripadvisor Rating</div>
          </div>
          <div className='upgadeify-tripadvisor-reviews-header-rating'>
            <div className="upgadeify-tripadvisor-reviews-header-rating-text">{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
            <div className="upgadeify-tripadvisor-reviews-item-rating">
              <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
            </div>
          </div>
          <div className="upgadeify-badge-reviews-readmore">
            Read our { apiData.data.total_reviews } reviews
          </div>
        </div>
      </>
        ) : (
          <div className="no-inner-result-found">
            <p>No Tripadvisor reviews found please check the product number.</p>
          </div>
        )}
    </div>

    {showPopup && (
      <div className="upgadeify-badge-fixed-style">
        <div className='upgadeify-badge-style-inner' style={{backgroundColor: style_background_color}}>
            <button className="upgadeify-badge-fixed-style-close" onClick={togglePopup}>X</button>
          {Number(header_is_widget_title) === 1 && (
                <>
                <div className="upgadeify-badge-fixed-style-title">
                    <h2 style={{ color: style_widget_title_color,fontSize: style_widget_title_fonts_title_size }}>{header_title || ""}</h2>
                    <h2 style={{ color: style_widget_title_caption_color,fontSize: style_widget_title_fonts_caption_size }}>{header_caption || ""}</h2>
                </div>
              </>
            )}
            {Number(header_is_show_header) === 1 &&
                (Number(header_source_icon) === 1 ||
                    Number(header_rating) === 1 ||
                    Number(header_number_of_reviews) === 1 ||
                    Number(header_write_reviews_button) === 1) && (
                <div className="upgadeify-badge-fixed-style-header" style={{ backgroundColor: style_header_background_color,}}>
               
                    <div className='upgadeify-tripadvisor-reviews-header-left'>
                      {Number(header_source_icon) === 1 && (
                      <div className='upgadeify-tripadvisor-reviews-header-title'>
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 124 36" className="injected-svg"><path fill="#000" d="M39.265 16.355v-1.657h-2.58v9.855h2.58v-5.909c0-1.07.698-1.596 1.785-1.596h1.413v-2.35h-1.206c-.945 0-1.766.485-1.992 1.657Zm5.616-5.555c-.883 0-1.56.686-1.56 1.555 0 .849.677 1.535 1.56 1.535s1.56-.686 1.56-1.535c0-.869-.677-1.555-1.56-1.555Zm-1.288 13.754h2.576v-9.856h-2.575v9.856Zm14.844-4.928c0 2.813-2.318 5.094-5.178 5.094-1.154 0-2.2-.372-3.039-1v3.727h-2.575V14.698h2.575v.834c.84-.628 1.886-1 3.04-1 2.859 0 5.177 2.28 5.177 5.094Zm-2.592 0c0-1.528-1.26-2.767-2.812-2.767-1.553 0-2.813 1.24-2.813 2.767s1.26 2.767 2.813 2.767c1.552 0 2.812-1.238 2.812-2.767Zm47.353-.865-1.502-.405c-.989-.254-1.373-.552-1.373-1.066 0-.5.541-.851 1.315-.851.738 0 1.316.475 1.316 1.083v.056h2.374v-.056c0-1.789-1.482-2.99-3.69-2.99-2.185 0-3.773 1.2-3.773 2.855 0 1.287.867 2.258 2.38 2.66l1.439.387c1.093.298 1.5.628 1.5 1.22 0 .625-.588 1.045-1.462 1.045-.911 0-1.524-.568-1.524-1.41v-.057h-2.52v.056c0 2.022 1.654 3.435 4.024 3.435 2.282 0 3.939-1.38 3.939-3.28 0-.932-.424-2.152-2.443-2.682Zm-35.625-4.063h2.575v9.855h-2.575v-.834a5.036 5.036 0 0 1-3.04 1.001c-2.859 0-5.177-2.28-5.177-5.094 0-2.814 2.318-5.094 5.178-5.094 1.153 0 2.2.372 3.039 1v-.834Zm0 4.928c0-1.53-1.26-2.767-2.813-2.767-1.552 0-2.812 1.24-2.812 2.767s1.26 2.767 2.812 2.767c1.554 0 2.813-1.238 2.813-2.767Zm11.874-8.435h2.576v13.364h-2.576v-.834c-.838.628-1.885 1-3.039 1-2.859 0-5.177-2.28-5.177-5.094 0-2.813 2.318-5.094 5.177-5.094 1.154 0 2.2.372 3.04 1v-4.342Zm0 8.435c0-1.528-1.26-2.767-2.812-2.767-1.553 0-2.812 1.24-2.812 2.767s1.258 2.767 2.812 2.767c1.553 0 2.812-1.238 2.812-2.767Zm14.533 4.928h2.575v-9.856H93.98v9.856ZM95.268 10.8c-.883 0-1.56.686-1.56 1.555 0 .849.677 1.535 1.56 1.535s1.56-.686 1.56-1.535c0-.869-.677-1.555-1.56-1.555Zm21.505 8.826c0 2.813-2.318 5.094-5.177 5.094-2.86 0-5.178-2.28-5.178-5.094 0-2.814 2.318-5.094 5.178-5.094 2.859 0 5.177 2.28 5.177 5.094Zm-2.365 0c0-1.528-1.26-2.767-2.812-2.767-1.553 0-2.813 1.24-2.813 2.767s1.259 2.767 2.813 2.767c1.552 0 2.812-1.238 2.812-2.767ZM37.947 11.19h-9.88v2.26h3.658v11.102h2.566V13.451h3.657v-2.26h-.001Zm49.96 10.663-2.29-7.156h-2.705l3.436 9.856h3.1l3.456-9.856H90.2l-2.291 7.156Zm32.639-5.5v-1.656h-2.581v9.855h2.581v-5.909c0-1.07.698-1.596 1.785-1.596h1.413v-2.35h-1.207c-.945 0-1.764.485-1.991 1.657Z"></path><path fill="#34E0A1" d="M12 30c6.627 0 12-5.373 12-12S18.627 6 12 6 0 11.373 0 18s5.373 12 12 12Z"></path><path fill="#000" d="m20.032 15.338 1.569-1.701h-3.48A10.83 10.83 0 0 0 12 11.76c-2.273 0-4.371.692-6.11 1.877H2.4l1.57 1.701a4.763 4.763 0 0 0-1.566 3.533c0 2.64 2.148 4.78 4.797 4.78a4.79 4.79 0 0 0 3.26-1.274L12 24.045l1.537-1.667c.856.791 2 1.273 3.259 1.273 2.649 0 4.8-2.14 4.8-4.78a4.752 4.752 0 0 0-1.564-3.533ZM7.203 22.106a3.24 3.24 0 0 1-3.246-3.235 3.24 3.24 0 0 1 3.246-3.235 3.24 3.24 0 0 1 3.246 3.235 3.24 3.24 0 0 1-3.246 3.235Zm4.798-3.329c0-2.128-1.553-3.956-3.603-4.736A9.34 9.34 0 0 1 12 13.322c1.277 0 2.494.257 3.603.719-2.049.782-3.602 2.608-3.602 4.736Zm4.796 3.33a3.24 3.24 0 0 1-3.246-3.236 3.24 3.24 0 0 1 3.246-3.235 3.24 3.24 0 0 1 3.246 3.235 3.24 3.24 0 0 1-3.246 3.235Zm0-4.933c-.94 0-1.701.759-1.701 1.696 0 .937.761 1.696 1.701 1.696a1.7 1.7 0 0 0 1.702-1.696 1.7 1.7 0 0 0-1.702-1.696Zm-7.892 1.697c0 .937-.762 1.696-1.702 1.696s-1.701-.759-1.701-1.696c0-.936.761-1.695 1.701-1.695a1.697 1.697 0 0 1 1.702 1.695Z"></path></svg>
                          <div className='upgadeify-tripadvisor-reviews-header-title-text' style={{color: style_header_text_color,}}>Reviews</div>
                      </div>
                      )}
                      <div className='upgadeify-tripadvisor-reviews-header-rating'>
                          {Number(header_rating) === 1 && (
                          <>
                              <div className="upgadeify-tripadvisor-reviews-header-rating-text" style={{color: style_header_text_color,}}>{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
                              <div className="upgadeify-tripadvisor-reviews-item-rating">
                                  <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
                              </div>
                          </>
                          )}
                          {Number(header_number_of_reviews) === 1 && (
                              <span className="upgadeify-tripadvisor-reviews-header-number-of-reviews-text">({apiData.data.total_reviews})</span>
                          )}
                      </div>
                </div>
                {Number(header_write_reviews_button) === 1 && (
                    <div className='upgadeify-tripadvisor-reviews-header-right'>
                        <a
                            href={apiData?.data?.google_url?.startsWith('http') ? apiData.data.google_url : `https://${apiData.data.google_url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='upgadeify-tripadvisor-reviews-header-button'
                            style={{color: style_header_write_review_text_color,backgroundColor: style_header_write_review_background_color,fontSize: header_write_review_button_type}}>Review us on Tripadvisor
                        </a>
                    </div>
                )}
            </div>
          )}
          {/* Reviews List */}
          {apiData.data.review_list.slice(0, visibleCount).map((review) => (
              <ReviewLoopItem key={review.id} review={review} handleReadMoreClick={handleReadMoreClick} reviewTabData={reviewTabData} expandedReviewId={expandedReviewId}/>
          ))}
          {/* Load More Button  */}
          {visibleCount < apiData.data.review_list.length && (
            <div className="load-more-button">
                <button onClick={handleLoadMore} style={{backgroundColor: style_load_more_button_color,color: style_load_more_button_text_color}}>Load More</button>
            </div>
          )}
         </div>   
      </div>
      )}
    </>
  );
};

const ReviewLoopItem = ({ review, handleReadMoreClick, reviewTabData, expandedReviewId }) => (
    <>
        <div className="upgadeify-tripadvisor-reviews">
            <div className='upgadeify-tripadvisor-reviews-item' style={{ padding: `${reviewTabData.layout_item_spacing}px`, backgroundColor: reviewTabData.style_review_background_color,}}>
               <div className='upgadeify-tripadvisor-reviews-head'>
                {Number(reviewTabData.review_is_show_reviewer_picture) === 1 && (
                    <div className="upgadeify-tripadvisor-reviews-item-image">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}

                          

                    </div>
                )}
                <div className='upgadeify-tripadvisor-reviews-item-name'>
                    {Number(reviewTabData.review_is_show_reviewer_name) === 1 && (
                        Number(reviewTabData.setting_is_enable_external_links) === 1 && review.author_url ? ( 
                            <a
                                href={review.author_url} 
                                target={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "_blank" : "_self"}
                                rel={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                style={{ color: reviewTabData.style_review_reviewer_name_color }}
                            >
                                <span className="upgadeify-tripadvisor-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>{review.name}</span>
                            </a>
                        ) : (
                            <span className="upgadeify-tripadvisor-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>
                                {review.name}
                            </span>
                        )
                    )}

                    {Number(reviewTabData.review_is_show_verified_badge) === 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="review-verified-badge-icon" aria-hidden="true">
                            <path fill={reviewTabData.style_review_verified_badge_color} d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path>
                        </svg>
                    )}

                    <span className="upgadeify-tripadvisor-reviews-item-date"> 
                        {Number(reviewTabData.review_is_show_date) === 1 && (
                            <span style={{color: reviewTabData.style_review_date_color,}}>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</span>
                        )}
                    </span>
                </div>
               </div>
                <div className="upgadeify-tripadvisor-reviews-item-content">
                    {Number(reviewTabData.review_is_show_rating) === 1 && (
                        <span className="upgadeify-tripadvisor-reviews-item-rating" style={{ fontSize: reviewTabData.style_review_rating_size }}>
                            <RatingStars average_rating={review.rating} newColor={reviewTabData.style_rating_stars_color}/>
                        </span>
                    )}
                    <div className="upgadeify-tripadvisor-reviews-item-text" style={{color: `${reviewTabData.style_review_text_color}`,fontSize: reviewTabData.style_review_text_font_size}}>
                        {expandedReviewId === review.id ? review.description: review.description.length > 50
                            ? `${review.description.slice(0, 50)}...`
                            : review.description
                        }
                    </div>
                    {review.description.length > 50 && (
                      <div className="upgadeify-tripadvisor-reviews-readmore" onClick={() => handleReadMoreClick(review)}
                        style={{
                          color: reviewTabData.style_read_more_color,
                          fontSize: reviewTabData.style_review_text_font_size
                        }}
                      >
                        {expandedReviewId === review.id ? 'Read less' : 'Read more'}
                      </div>
                    )}

                    {Number(reviewTabData.review_is_show_review_source) === 1 && (  
                        <div className='upgadeify-tripadvisor-reviews-item-image-badge'>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><circle cx="12" cy="12.5" r="10" fill="#34E0A1"></circle><path fill="#000" d="m18.167 10.528 1.194-1.306h-2.667A8.236 8.236 0 0 0 12 7.778c-1.75 0-3.361.528-4.694 1.444H4.639l1.194 1.306c-.75.666-1.194 1.639-1.194 2.722a3.663 3.663 0 0 0 3.667 3.667c.972 0 1.833-.362 2.5-.973L12 17.222l1.167-1.278a3.652 3.652 0 0 0 2.5.973 3.663 3.663 0 0 0 3.666-3.667 3.584 3.584 0 0 0-1.166-2.722Zm-9.834 5.194a2.49 2.49 0 0 1-2.5-2.5 2.49 2.49 0 0 1 2.5-2.5 2.49 2.49 0 0 1 2.5 2.5c-.027 1.39-1.139 2.5-2.5 2.5ZM12 13.167c0-1.64-1.194-3.056-2.75-3.64A7.049 7.049 0 0 1 12 8.973a6.95 6.95 0 0 1 2.75.556c-1.556.61-2.75 2-2.75 3.639Zm3.667 2.555a2.49 2.49 0 0 1-2.5-2.5 2.49 2.49 0 0 1 2.5-2.5 2.49 2.49 0 0 1 2.5 2.5 2.49 2.49 0 0 1-2.5 2.5Zm0-3.778c-.723 0-1.306.584-1.306 1.306a1.304 1.304 0 1 0 2.611 0c0-.722-.583-1.306-1.305-1.306ZM9.639 13.25c0 .722-.583 1.306-1.306 1.306a1.304 1.304 0 0 1-1.305-1.306 1.304 1.304 0 1 1 2.611 0Z"></path></svg>
                            Posted On   
                            <> <a href={`https://www.tripadvisor.com`} target="blank">Tripadvisor</a></> 
                        </div> 
                    )} 
                </div>
            </div>
        </div>
    </>
);

export default FloatingWidget;
